import {useTheme} from 'contexts/ThemeContext';
import {Stream} from 'models/Stream';
import React, {useEffect} from 'react';
import {View, ViewStyle} from 'react-native';
import styleSheet from './styles';

export interface RTCCustomViewProps {
  id: string;
  isMyStream: boolean;
  isSharing: boolean;
  isVideoEnabled?: boolean;
  children: JSX.Element;
  style: ViewStyle;
  stream: Stream;
}

const RTCCustomView = (props: RTCCustomViewProps) => {
  const styles = styleSheet(useTheme());

  useEffect(() => {
    const video = document.getElementById(props.id) as HTMLVideoElement;

    if (video) {
      video.srcObject = props.stream as unknown as MediaProvider;

      if (props.isMyStream) {
        video.muted = true;
      }

      video.onloadedmetadata = function (e) {
        video?.play();
      };
    }
  }, [props.id]);

  return (
    <View style={props.style}>
      <video
        id={props.id}
        height={!props.isVideoEnabled ? '0px' : '100%'}
        style={
          props.isMyStream && !props.isSharing
            ? {transform: 'rotateY(180deg)'}
            : {}
        }
      />
      {props.children}
    </View>
  );
};

export default RTCCustomView;
